import { RadioGroup } from '@headlessui/react';
import { useField } from 'formik';
import { useEffect } from 'react';
import SpecialInstructions from './SpecialInstructions';

export default function YesNoExplain({
  name,
  label,
  describeMessage,
  specialInstructions,
  layout,
}) {
  console.warning(
    'You are using a deprecated component: YesNoExplain. Replace with: a combination of YesNo and Explain.'
  );
  const [field, meta, helpers] = useField(name);
  const { setValue } = helpers;

  const options = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];

  useEffect(() => {
    if (field?.value === '') setValue([undefined, '']);
  }, [field.value]);

  const handleSelect = (value) => {
    if (value) {
      setValue([value, field.value[1]]);
    } else {
      setValue([value]);
    }
  };

  const handleTextInput = (e) => {
    setValue([true, e.target.value]);
  };

  if (!field || !field.value) {
    return <div>loading...</div>;
  }
  if (field.value === '') {
    return <div>loading...</div>;
  }

  return (
    <div className="">
      <div className="py-9 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-primary-200">
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label
          className={`block text-base text-primary-700 font-medium sm:mt-px sm:pt-2 mb-2 ${
            layout === 'columns' ? 'sm:col-span-1' : 'sm:col-span-3'
          }`}
        >
          {label}
        </label>
        {specialInstructions && (
          <SpecialInstructions instructions={specialInstructions} />
        )}

        <RadioGroup
          value={field?.value[0]}
          onChange={handleSelect}
          className={`${
            layout === 'columns' ? 'sm:col-span-1' : 'sm:col-span-3'
          } self-cent justify-self-center `}
        >
          <RadioGroup.Label className="sr-only">{label}</RadioGroup.Label>
          <div className="flex">
            {options.map((option) => (
              <RadioGroup.Option
                key={option.value}
                value={option.value}
                className={({ active, checked }) => `${
                  active
                    ? 'ring-2 ring-offset-2 ring-offset-neutral-500 ring-white ring-opacity-60'
                    : ''
                }
                  ${
                    checked
                      ? 'bg-neutral-500 bg-opacity-75 border-transparent'
                      : 'bg-white'
                  }
                    relative rounded px-5 py-2 mx-2 cursor-pointer flex focus:outline-none border border-primary-300`}
              >
                {({ checked }) => (
                  <div className="flex items-center justify-between w-full">
                    <div className="flex items-center">
                      <div className="text-base">
                        <RadioGroup.Label
                          as="p"
                          className={`font-medium  ${
                            checked ? 'text-white' : 'text-primary-800'
                          }`}
                        >
                          {option.label}
                        </RadioGroup.Label>
                      </div>
                    </div>
                  </div>
                )}
              </RadioGroup.Option>
            ))}
          </div>
        </RadioGroup>

        {field.value[0] && (
          <div className="sm:col-span-3 mb-9">
            {describeMessage || <p>Please describe:</p>}
            <div className="mt-1 relative col-span-2 rounded shadow-sm">
              <textarea
                rows={6}
                value={field.value[1]}
                onChange={handleTextInput}
                type="text"
                className={`block w-full shadow-sm focus:ring-neutral-500 focus:border-neutral-500  text-base rounded ${
                  meta.touched && meta.error
                    ? 'border-warning'
                    : 'border-neutral-300'
                }`}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
